/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".shift-options[_ngcontent-%COMP%]{position:relative;text-align:right}.file-url[_ngcontent-%COMP%]{font-size:18px;padding-right:3px}"];
export { styles as styles };
